import React, { useContext, useEffect, useState } from "react";
import { ModalContext } from "../../contexts/ModalContext.js";
import { ServerContext } from "../../contexts/ServerContext.js";
import { ResponsiveContext } from "../../contexts/ResponsiveContext.js";
import { BounceLoader, ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Autoplay } from "swiper/modules";
import { emptySpace } from "../../index.js";
import HeroSection from "../../components/Herosection/HeroSection.jsx";
import ModalBlocker from "../../components/ModalBlocker/ModalBlocker.jsx";
import WP_TheIsland from "../../assets/WP_TheIsland_450x253.webp";
import WP_Ragnarok from "../../assets/WP_Ragnarok_450x253.webp";
import WP_Valguero from "../../assets/WP_Valguero_450x253.webp";
import WP_TheCenter from "../../assets/WP_TheCenter_450x253.webp";
import WP_Astraeos from "../../assets/WP_Astraeos_450x253.webp";
import WP_ScorchedEarth from "../../assets/WP_ScorchedEarth_450x253.webp";
import WP_Aberration from "../../assets/WP_Aberration_450x253.webp";
import WP_Extinction from "../../assets/WP_Extinction_450x253.webp";
import WP_LostColony from "../../assets/WP_LostColony_450x253.webp";
import how2find from "../../assets/how2find.webp";
import cs from "../../assets/cs.webp";
import dk from "../../assets/dk.webp";
import paleo from "../../assets/paleoark.webp";
import drakara from "../../assets/drakara.webp";
import spyglass from "../../assets/spyglass.webp";
import asa_logo_info from "../../assets/asa_logo_info.webp";

import "swiper/css";
import "swiper/css/grid";
import "./serverpage.scss";

const bannerImages = {
  Ragnarok: WP_Ragnarok,
  Valguero: WP_Valguero,
  Astraeos: WP_Astraeos,
  TheIsland: WP_TheIsland,
  TheCenter: WP_TheCenter,
  ScorchedEarth: WP_ScorchedEarth,
  Aberration: WP_Aberration,
  Extinction: WP_Extinction,
  LostColony: WP_LostColony,
};

const randomNames = ["Mahuu"];

const platforms = ["steam", "xbox", "playstation", "windows"];

const randomIndex = Math.floor(Math.random() * randomNames.length);

const modIds = [ 1460513,940975,929420,930494,928824,929110,949521,957494,928565,1201667,930442,931874,1063373,1058390,937184,966079,1299726,942008,939604,970540,1105106,972484,1382641,941450 ];

const Serverpage = () => {
  const { servers, serverInfos, serverPlayers, isLoadingRcon } = useContext(ServerContext);
	const { phoneView } = useContext(ResponsiveContext);
  const { isModalOpen, setIsModalOpen } = useContext(ModalContext);

  const [modsInfo, setModsInfo] = useState([]);
  const [invisMode, setInvisMode] = useState(true);

  const [modalImage, setModalImage] = useState(null);
  const [currentHeroSectionHeight, setCurrentHeroSectionHeight] = useState(0);

  const handleImageModal = (src) => {
    setIsModalOpen((prev) => !prev);
    setModalImage(src);
  };

  const scrollToMods = (e) => {
    e.preventDefault();
    const element = document.getElementById("mods");
    if (!element) return;

    const yOffset = -80;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  // Mods Info laden (bleibt lokal)
  useEffect(() => {
    const fetchModsInfo = async () => {
      try {
        const results = await Promise.all(
          modIds.map(async (modId) => {
            const res = await fetch(
              `https://nexark.de/proxy.php?mode=curseforge&modId=${modId}`
            );
            if (!res.ok) throw new Error(`Fehler beim Laden von Mod ${modId}`);
            const json = await res.json();
            return json.data ?? null;
          })
        );

        setModsInfo(results.filter(Boolean));
      } catch (err) {
        console.error("Fehler beim Laden der Mods:", err);
      }
    };

    fetchModsInfo();
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      const heroElement = document.querySelector(".hero-section");
      if (heroElement) setCurrentHeroSectionHeight(heroElement.offsetHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      <div className='main-wrapper serverpage-wrapper'>
        <HeroSection name={'UNSERE SERVER'} />
        <div className='section-wrapper server-container-wrapper' style={{ minHeight: `calc(100dvh - ${currentHeroSectionHeight}px - 40px)` }}>
					<Swiper
						className='server-swiper'
						modules={[A11y, Autoplay]}
						spaceBetween={20}
						// slidesPerView={phoneView ? 1 : 3}
						allowTouchMove={true}
						// centeredSlides={phoneView ? true : false}
						autoplay={{
							disableOnInteraction: false,
							delay: 7000,
							pauseOnMouseEnter: false,
						}}
						slidesPerView={1}
						slidesPerGroup={1}
						centeredSlides={false}

						breakpoints={{
							768: {
								slidesPerView: 2,
								slidesPerGroup: 1,
								centeredSlides: false,
							},
							1024: {
								slidesPerView: 3,
								slidesPerGroup: 1,
								centeredSlides: false,
							},
						}}
					>
					{servers.map((server, idx) => {
						const info = serverInfos[idx] || {};
						return (
							<SwiperSlide className="server-container" key={`server-banner${idx}`}>
								<div className="thumbnail-wrapper">
									<img src={bannerImages[server.map]} className="thumbnail" alt={server.name} />
								</div>
								<div className='server-info-wrapper'>
									{isLoadingRcon && <ClipLoader className='loader' color='var(--color)' size={15}/>}
									{!isLoadingRcon && <span className="loader2" title={!info.isRotation ? "Feste Karte" : "Zeitlich limitierte Karte"} style={{filter: 'drop-shadow(1px 1px 3px rgba(0,0,0,0.5))'}}>{!info.isRotation ? '📌' : '⏳'}</span>}
									<h3>{server.name}</h3>
									<div className='server-info-container'>
										<div className='server-info-row'>
											<div className='server-info-subrow'>
												<p>Status:</p>
												{info.status === "online" ? (
													<>
														<BounceLoader size={16} color='#24d56b' />
														{!phoneView &&<p><code>Online</code></p>}
													</>
												) : info.status === "starting" ? (
													<>
														<BounceLoader size={16} color='#f5a623' />
														{!phoneView &&<p><code>Restarting</code></p>}
													</>
												) : info.status === "updating" ? (
													<>
														<BounceLoader size={16} color='#2e86de' />
														{!phoneView &&<p><code>Updating</code></p>}
													</>
												) : info.status === "offline" ? (
													<>
														<BounceLoader size={16} color='#e74c3c' />
														{!phoneView &&<p><code>Offline</code></p>}
													</>
												) : (
													<>
														<BounceLoader size={16} color='var(--color)' />
														<p>Syncing..</p>
													</>
												)}
											</div>
											<div className="server-info-subrow">
												<p>Version: <code style={{fontSize: '14px'}}>{info.version}</code></p>
											</div>
										</div>
										<div className='server-info-row'>
											<div className="server-info-subrow"><p>Crossplay: <i className="small-info bi bi-check2"></i></p></div>
											<p>
												Platforms:{' '}
												{platforms.map((platform, idx) => (
													<span key={platform + idx}>
														<i className={`bi bi-${platform}`}></i>
														{idx < platforms.length - 1 && ' '}
													</span>
												))}
											</p>
										</div>
										<div className='server-info-row'>
											<div className="server-info-subrow">
												<p><span className='link' onClick={scrollToMods}>Mods <i className="bi bi-box-arrow-down-right"></i>:</span> <i className="small-info bi bi-check2"></i></p>
											</div>
											<p>Slots: <code style={{fontSize: '14px', display: 'inline-flex', gap: '2px'}}>
												<span className={serverPlayers[idx]?.length > 0 ? 'small-info' : 'small-info-red'}>
													{serverPlayers[idx]?.length}
												</span>
												<p>/</p>
												{info.player_max}
												<span style={{color: 'red'}}>*</span>
												{emptySpace}</code>
											</p>
										</div>
										<br />
										<p>Aktuelle Spieler:</p>
										<p style={{ textAlign: 'start', fontSize: '14px' }}>
											{serverPlayers[idx]?.length ? (
												(() => {
													const players = serverPlayers[idx];
													const maxVisible = 7;
													const remaining = players.length - maxVisible;
													const displayed = players.slice(0, maxVisible).map(name =>
														invisMode && name.includes("Your wifes Crush")
															? randomNames[randomIndex]
															: name
													);
													return (
														<>
															{displayed.join(', ')}
															{remaining > 0 && `, .. ${remaining} weitere${remaining === 1 ? 'r' : ''} Spieler`}
														</>
													);
												})()
											) : (
												'Keine Spieler online'
											)}
										</p>
									</div>
									<br />
									<small style={{fontSize: '12px'}}><span style={{color: 'red'}}>*</span> Wird nach Bedarf angepasst</small>
									<div className='server-tag-container'>
										<small className='server-tag'>PVE</small>
									</div>
								</div>
							</SwiperSlide>
						)
					})}
					</Swiper>
        </div>
        <div className="section-wrapper how-to-find-wrapper">
          <div className='how-to-find-info-wrapper'>
            <h2>Wie findest du unsere Server?</h2>
            <div className='how-to-find-info-paragraph-wrapper'>
              <ul>
                <li>Achte auf alle in <strong>rot und grün</strong> markierten Boxen.</li>
                <li>Stelle sicher, in der Server-Auswahl den Reiter auf <strong>Unofficial/Inoffiziell</strong> gewechselt zu haben.</li>
                <li>Die Map-Auswahl und den Spielmodus stellen wir auf <strong>All Maps/Alle Karten und All/Alle</strong>.</li>
                <li>Versichert euch in der grün markierten Box, alle Haken <strong>entfernt</strong> zu haben.</li>
                <li><strong>Show Player Servers/Zeige Spieler Server</strong> habt ihr den Haken <strong>gesetzt</strong>.</li>
                <li>Und zu guter Letzt oben rechts in der Suchleiste <em><strong>"nexark"</strong></em> eingeben.</li>
                <br />
                <li>Wenn du dass alles eingestellt hast, wirst du unsere Server finden und kannst joinen.</li>
              </ul>
            </div>
            <p>Du kannst auf das Bild klicken um es zu vergrößern, dass hilft dir ggf. die richtigen Einstellungen zu finden.</p>
            <p>Das NEXARK - Team, wünscht dir und solltest du welche mitbringen auch deinen Freunden, ganz viel Spaß und Erfolg, beim Bauen, Zähmen .. Überleben!</p>
          </div>
          <div className='how-to-find-image-wrapper'>
            <img src={how2find} loading='lazy' alt="" onClick={((e) => handleImageModal(e.currentTarget.src))} />
          </div>
        </div>
				<div className='section-wrapper mods-wrapper' id='mods'>
					<div className='section-heading'>
						<h2><i className="bi bi-ui-checks-grid"></i> Mods die wir nutzen ({modsInfo?.length})</h2>
						<hr />
					</div>
					<div className='mods-info-wrapper'>
						{modsInfo.map((mod, idx) => (
							<div className='mod-wrapper' key={mod.name + idx}>
								<div className='mod-image-wrapper'>
									<Swiper
										modules={[A11y, Autoplay]}
										spaceBetween={0}
										slidesPerView={1}
										allowTouchMove={false}
										autoplay={{
											disableOnInteraction: false,
											delay: 5000,
											pauseOnMouseEnter: true,
										}}
									>
										{mod?.logo?.thumbnailUrl && (
											<SwiperSlide key="logo">
												<img
													src={mod.logo.thumbnailUrl}
													alt={`${mod.name} Logo`}
												/>
											</SwiperSlide>
										)}
										{/* <SwiperSlide key="logo">
											<img src={mod.logo.thumbnailUrl} alt={`${mod.name} Logo`} />
										</SwiperSlide> */}
										{(mod.screenshots && mod.screenshots.length > 0) && 
											mod.screenshots.map((screenshot, index) => (
												<SwiperSlide key={"screenshot" + index}>
													<img src={screenshot.thumbnailUrl} alt={`${mod.name} Screenshot ${index + 1}`} />
												</SwiperSlide>
											))
										}
									</Swiper>
								</div>
								<div className='mod-info-wrapper'>
									<h4><Link to={mod.links.websiteUrl} className='mod-link' target="_blank" rel="noopener noreferrer">{mod.name} <i className="bi bi-box-arrow-up-right"></i></Link></h4>
									<div className='mod-info-paragraph-wrapper'>
										<div className='authors-wrapper'>
											<p>
												<strong>Author(s)</strong>: {mod.authors.map((author, index) => (
													<span key={author.name}>
														<Link to={author.url} className='author-link' target="_blank" rel="noopener noreferrer">{author.name} <i className="bi bi-box-arrow-up-right"></i></Link>
														{index < mod.authors.length - 1 ? ', ' : ''}
													</span>
												))}
											</p>
										</div>
										<div className='desc-wrapper'>
											<p><strong>Beschreibung:</strong></p>
											<p>{mod.summary}</p>
										</div>
										<p><strong>Crossplay: </strong> {mod.supportsCrossPlatform === true ? "✅" : "❌"}</p>
										<div className='last-update-wrapper'>
											<p><strong>Zuletzt aktualisiert:</strong> {
												(() => {
													const date = new Date(mod.dateReleased);
													const day = date.getDate().toString().padStart(2, '0');
													const months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
													const month = months[date.getMonth()];
													const year = date.getFullYear();
													return `${day}. ${month} ${year}`;
												})()
											}</p>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
				<div className="section-wrapper good-to-know-wrapper">
					<div className='section-heading'>
						<h2><i className="bi bi-lightbulb"></i> Gut zu wissen</h2>
						<hr />
					</div>
					<div className="good-to-know-info-wrapper">
						<div className='hint-wrapper'>
							<div className='hint-image-wrapper'>
								<img src={asa_logo_info} alt="" className='hint-image'/>
							</div>
							<div className='hint-info-wrapper'>
								<h3>Unnützes aber dennoch hilfreiches Wissen</h3>
								<ul>
									<li><strong>Beginner</strong></li>
									<ul>
										<li>Eine <strong>Axt</strong> sammelt mehr <strong>Leder/Holz/Stein</strong>, eine <strong>Spitzhacke</strong> dagegen mehr <strong>Fleisch/Stroh/Feuerstein</strong>.</li>
										<li><strong>Lagerkiste & Bett</strong>: Frühe Startbase <em>(2x2, 3x3)</em> um erst einmal reinzufinden und einen Wiedereinstiegspunkt zu haben.</li>
										<li><strong>Steinschleuder + Bola</strong>: Die Schleuder <em>(Slingshot)</em> ist überraschend effektiv gegen kleinere Tiere <em>(Dilos, Parasaur, Trike)</em>, die Bola kann kleinere Dinos kurzzeitig festhalten, ideal für erste Tames ohne viel Risiko.</li>
									</ul>
									<li><strong>Advanced</strong></li>
									<ul>
										<li><strong>Narcobeeren</strong> geben einen Gegenwert von <strong><em>7.5 Benommenheit</em></strong>, wogegen <strong>Narkosemittel</strong> einen Wert von <strong><em>40</em></strong> gibt.</li>
										<li><strong>Räucherkammer + Jerky-Produktion</strong>: Öl + Zündpulver + gegrilltes Fleisch = Räucherfleisch <em>(Jerky)</em>, frühzeitig herstellen, denn Jerky hält am längsten und du brauchst es für Kibble!</li>
										<li><strong>Mörser + Lagerfeuer = frühes XP-Farming</strong>: Große Mengen an Narcotics und gekochtem Fleisch zu produzieren bringt schon auf Low-Leveln konstant XP. Lagerfeuer stellt zusätzlich Holzkohle her <em>(wichtig für Schwarzpulver später)</em>.</li>
									</ul>
									<li><strong>Expert</strong></li>
									<ul>
										<li><strong>Super Early: Phiomia + Komposter = Düngefabrik</strong>: Ein gezähmter Phiomia <em>(mit Stimbeeren gefüttert)</em> produziert Massen an Kot für Komposter - so hast du immer Dünger, bevor du Dung Beetle hast.</li>
										<li><strong>Schnecken (Achatina) produzieren Zementpaste - aber nur mit Cake</strong>: Zähme früh Schnecken und füttere sie regelmäßig mit süßen Gemüsekuchen, dann hast du automatisch Cementing Paste - spart tonnenweise Chitin und Stein.</li>
										<li><strong>Grappling Hook für schnelle Vertikalbewegung</strong>: Ermöglicht blitzschnelles Hochziehen an Klippen und Felsen - spart Zeit und Ausdauer beim Erkunden und Farmen. Ebenfalls gut um Carnivoren zu entkommen.</li>
									</ul>
									<li><strong>Grandmaster</strong></li>
									<ul>
										<li><strong>Gacha Farm</strong>: Für Ressourcen maximal auf 160% Crafting Skill leveln, für Items bis zu 260% (alles darüber ist minmaxing).</li>
										<li><strong>Ovis Farm</strong>: Ovis Züchten; für extrem viel Leder, Pelz und Hammelfleisch (Leben/Nahrung leveln, zum Abfarmen - Kettensäge empfohlen).</li>
										<li><strong>Kibble (Trockenfutter)</strong>: <i>Höheres</i> Kibble <strong>kann auch</strong> für Dinos benutzt werden die <i>niedrigeres</i> <strong>verlangen</strong>. (Extraordinary Kibble (hellblau) kann für jeden Dino benutzt werden mit selbem Effekt)</li>
									</ul>
								</ul>
							</div>
						</div>
						<div className='hint-wrapper'>
							<div className='hint-image-wrapper'>
								<img src={cs} alt="" className='hint-image'/>
							</div>
							<div className='hint-info-wrapper'>
								<h3>Cybers Structures (Cybers Structures QoL+) [MOD]</h3>
								<ul>
									<li><strong>CS Gravestone</strong></li>
									<ul>
										<li>Mit dem CS Gravestone (Grabstein) könnt ihr <strong>euer Inventar zurückerlangen</strong>, wenn ihr gestorben seid.</li>
										<li><strong>Wichtig</strong>: Wenn ihr sterbt während ihr <strong>offline</strong> seid, ist euer Inventar <strong>futsch</strong>. <em>(Passiert auch, wenn ihr durch die Maps buggt.)</em></li>
									</ul>
									<li><strong>CS Strukturen</strong></li>
									<ul>
										<li>Die meisten Strukturen aus CS haben eine <strong>höhere Reichweite</strong> als ihre Vanilla Äquivalente. <em>(CS Generator, CS Feeding Through, ...)</em></li>
										<li>Der <strong>CS Water Intake</strong> <em>(Stone & Metal)</em> kann <strong>überall</strong> platziert werden. Somit könnt ihr <strong>überall</strong> Wasser anzapfen.</li>
									</ul>
									<li><strong>CS Helfer</strong></li>
									<ul>
										<li><strong>Nanny</strong>: Füttert und prägt <em>(Prägung deaktivierbar)</em> geschlüpfte Babys <strong>bis</strong> sie <em>jugendlich</em> sind, in ihrer Range.</li>
										<li><strong>Farmer</strong>: Sammelt und verteilt Dünger <strong>in die Beete</strong>.</li>
										<li><strong>Gardener</strong>: Sammelt die Ernte <strong>aus den Beeten</strong> und gräbt die Beete um <em>(Ernte-Bonus)</em>.</li>
										<li><strong>Collector</strong>: Sammelt verschiedenste Items <strong>vom Boden</strong> <em>(einstellbar)</em>. Kann auch Kot <strong>sammeln</strong> und in Käfer/Komposter <strong>verteilen</strong>.</li>
									</ul>
								</ul>
							</div>
						</div>
						<div className='hint-wrapper'>
							<div className='hint-image-wrapper'>
								<img src={spyglass} alt="" className='hint-image'/>
							</div>
							<div className='hint-info-wrapper'>
								<h3>Super Spyglass (Super Spyglass Plus) [MOD]</h3>
								<ul>
									<li>Dieses Fernglass bietet 3 Optionen zum Crafting: <em>Consumable, Weapon oder Skin</em>.</li>
									<ul>
										<li><strong>Consumable</strong>: Togglebar im Inventar (hover + E).</li>
										<li><strong>Weapon</strong>: Wie man es kennt, um's in die Hand zu nehmen.</li>
										<li><strong>Skin</strong>: Auf einem Helm anwendbar.</li>
									</ul>
									<li><strong>Bessere Ansicht</strong> und vorallem wichtig für Züchter, da ihr <strong>alle Stats</strong> sehen könnt.</li>
									<li>Mit diesem Fernglas könnt ihr sehen <strong>welches Essen</strong> euer Ziel Dino gern hat und <strong>wie viel</strong> er benötigt.</li>
								</ul>
							</div>
						</div>
						<div className='hint-wrapper'>
							<div className='hint-image-wrapper'>
								<img src={drakara} alt="" className='hint-image'/>
								<div className="inside-hint-image-wrapper-info">
									<h4 className="inside-hint-heading">Maps:</h4>
									<ul>
										<li>Valguero</li>
										<li>The Island</li>
										<li>Aberration</li>
									</ul>
								</div>
							</div>
							<div className='hint-info-wrapper'>
								<h3>Drakara (Isle of Myths: Skyshroud Drakara) [MOD]</h3>
								<ul>
									<li><strong>Zähmung</strong></li>
									<ul>
										<li>Passiv-Zähmung</li>
										<li><strong>Ihr braucht</strong>: <em>Drakara Kibble</em> - wird <strong>im Kochtopf</strong> hergestellt.</li>
										<li><strong>Optional (zu empfehlen)</strong>: <em>Instinct Nullifier</em> - Wie Insektenspray für Insekten, nur hier, für Drakara's. Wird <strong>im Mörser</strong> hergestellt.</li>
									</ul>
									<li><strong>Zähm-Vorgang (empfohlen)</strong></li>
									<ul>
										<li><strong>Instinct Nullifier</strong> und 5-8 <strong>Drakara Kibble</strong> bereit halten. <em>(Kibble auf dem 0 Slot)</em></li>
										<li>Ihr <strong>nutzt</strong> den <em>Instinct Nullifier</em> um <strong>der Aufmerksamkeit</strong> der Drakara's <strong>zu entgehen</strong>. <em>(Wenn ihr sie angreift hat der Nullifier <strong>keine Wirkung</strong> mehr)</em></li>
										<li>Solange dieser Effekt wirkt und ihr die Kibble bereit habt, könnt ihr euch quasi an den zu zähmenden Drakara wagen.</li>
										<li>Im besten Fall macht der Drakara eurer Wahl eine Pause auf dem Boden, so könnt ihr die Zähmung starten.</li>
									</ul>
								</ul>
							</div>
						</div>
						<div className='hint-wrapper'>
							<div className='hint-image-wrapper'>
								<img src={dk} alt="" className='hint-image'/>
								<div className="inside-hint-image-wrapper-info">
									<h4 className="inside-hint-heading">Maps:</h4>
									<ul>
										<li>TheCenter</li>
										<li>Scorched Earth</li>
										<li>Extinction</li>
									</ul>
								</div>
							</div>
							<div className='hint-info-wrapper'>
								<h3>Zaldrir Dragon (Dragon's Kingdom) [MOD]</h3>
								<ul>
									<li><strong>Zähmung</strong></li>
									<ul>
										<li>Wartet, bis der wilde Drache landet und sich zum Schlafen legt.</li>
										<li>Füttere <strong>rohes Hammelfleisch (Raw Mutton)</strong>, um die Zähmung zu starten.</li>
										<li>Danach frisst er nur noch <strong>gezähmte lebende Schafe</strong>.</li>
										<li><em>Tipp:</em> Schafe mit hoher Gesundheit zähmen schneller!</li>
									</ul>
									<li><strong>Zähm-Fortschritt & Reiten</strong></li>
									<ul>
										<li>Ab <strong>50% Zähm-Fortschritt</strong> lässt sich der Drache reiten, um die Zähmung abzuschließen.</li>
										<li>Töte <strong>große, hochlevelige Dinos</strong>, um Taming- und <em>Bond Strength</em> zu erhöhen.</li>
										<li>Die Bond Strength wird beim Taming <strong>direkt in Imprint</strong> umgewandelt.</li>
										<li><em>Hinweis:</em> Ein starkes Schaf auf <strong>passiv</strong> bereithalten, bevor das erste Hammelfleisch gegeben wird!</li>
									</ul>
									<li><strong>"Chosen Mechanic" (Sonderzähmung)</strong></li>
									<ul>
										<li>Beim ersten Füttern gibt es eine <strong>2% Chance</strong> auf diesen Spezialmodus.</li>
										<li>Der Drache lässt sich dann <strong>sofort zähmen, nur durch Jagen</strong>.</li>
										<li>Funktioniert <strong>einmal pro Spieler, pro Drachentyp</strong>.</li>
									</ul>
									<li><strong>Zähmverweigerung</strong></li>
									<ul>
										<li>Nur der <strong>Juvenile T1</strong>-Drache hat 0% Verweigerungschance.</li>
										<li>Andere Drachen können das Zähmen mit <strong>72-97% Wahrscheinlichkeit</strong> verweigern.</li>
										<li>Nach Verweigerung schläft der Drache für <strong>ca. 5 Minuten</strong> und ignoriert dich.</li>
										<li>Danach kannst du <strong>erneut versuchen</strong>, ihn zu zähmen.</li>
									</ul>
								</ul>
							</div>
						</div>
						<div className='hint-wrapper'>
							<div className='hint-image-wrapper'>
								<img src={paleo} alt="" className='hint-image'/>
								<div className="inside-hint-image-wrapper-info">
									<h4 className="inside-hint-heading">Maps:</h4>
									<ul>
										<li>Tyrannosauren - überall dort, wo auch der normale Spawn ist.</li>
										<li>Tarbosauren - Wüsten-Regionen & Rex Spawns</li>
										<li>EVO Giga - ersetzt alle Giga Spawns, also überall dort wo Giga's spawnen.</li>
									</ul>
								</div>
							</div>
							<div className='hint-info-wrapper'>
								<h3>Paleo ARK - Evolution | Apex Predators [MOD]</h3>
								<p>Die Paleo <strong>Evo Rexe und Evo Gigas</strong> <i>ersetzen</i> <strong>alle</strong> Vanilla Rex und Giga Spawns.</p>
								<ul>
									<h2>Evo Rex</h2>
									<li><strong>Zähmung</strong></li>
									<ul>
										<li>Kann nicht mit normalen KO-Methoden gezähmt werden, sondern muss <strong>angefreundet</strong> werden.</li>
										<li>Ziehe mehrere Kadaver mit <strong>mindestens 150 <a className='link' href='https://ark.wiki.gg/wiki/Drag_Weight' target='_blank' rel='noreferrer noopener'>Drag Weight <i className="bi bi-box-arrow-up-right"></i></a></strong> zu einem wilden Tyrannosaurus/Tarbosaurus (auch Legacy Varianten).</li>
										<li>Der Tyrannosaurus wird herankommen und fressen.</li>
										<li>Es ist egal, ob du den Kadaver in der Hand hältst - er wird <strong>nicht</strong> feindlich gegenüber dir, deinen gezähmten oder wilden Dinos, während er frisst.</li>
										<small className='small-info' style={{marginLeft: '40px', fontStyle: 'italic'}}>(Tipp: Schild dabei haben um im Falle, Schaden blocken zu können)</small>
										<li>Ein Symbol über ihm zeigt den aktuellen <strong>Vertrauensstand</strong> an. Du bringst ihm solange Kadaver bis er maximal vertraut ist.</li>
									</ul>
									<li><strong>Vertrauen &amp; Abschluss</strong></li>
									<ul>
										<li>Bei <strong>maximalem Vertrauen</strong> erlaubt der Tyrannosaurus, dass du ihn <strong>besteigst</strong>.</li>
										<li>Danach müssen Dinos getötet werden, um die Zähmung abzuschließen. Der Tyrannosaurus sucht sich sein nächstes Ziel selbst aus. </li>
										<li>Welches Ziel der Tyrannosaurus im Visier hat, wird dir mittig oben am Bildschirmrand angezeigt. Finde das Ziel und töte es, um die Zähmung voranzubringen.</li>
										<li>Das wiederholst du solange, bis die Zähmung abgeschlossen ist.</li>
										<small className='small-info' style={{marginLeft: '40px', fontStyle: 'italic'}}>(Tipp: Versuche in die Nähe größerer Dinos zu kommen, umso mehr % bekommt er durch die Tötung wenn er diese targetiert.)</small>
									</ul>
									<h2>Evo Giga</h2>
									<li><strong>Zähmung</strong></li>
									<ul>
										<li>Kann nicht mit normalen KO-Methoden gezähmt werden, sondern muss <strong>herausgefordert</strong> werden, bis er sich erschöpft.</li>
										<li>Um die Zähmung zu starten, nähere dich einem Giganotosaurus, während du ein <strong>Giganotosaurus-Herz</strong> im Inventar hast.</li>
										<li>Der Giga wird zunächst schnuppern und dich dann herausfordern, indem er mit dem Schwanz auf den Boden schlägt und brüllt.</li>
										<li>Der Spieler mit dem Herz verliert eines davon, und erhält eine Benachrichtigung, dass er herausgefordert wurde.</li>
									</ul>
									<li><strong>Kampfphase &amp; Betäubung</strong></li>
									<ul>
										<li>Um den Giga zu betäuben, muss er gezähmte Kreaturen angreifen und beißen dürfen.</li>
										<li>Jeder erfolgreiche Biss fügt ihm Betäubung zu.</li>
										<li>Empfohlene Tanks: <strong>Brontosaurus</strong> oder andere sehr robuste Dinos mit hoher Gesundheit.</li>
										<li>Die zugefügte Betäubung pro Biss = <strong>Staminaverbrauch x10</strong>.</li>
										<li>Dieser Wert verdoppelt sich, wenn der Giga <strong>wütend</strong> ist. (Wenn man ihm selbst Schaden zufügt bis er wütend wird.)</li>
									</ul>
									<li><strong>Abschluss der Zähmung</strong></li>
									<ul>
										<li>Nachdem er schließlich einschläft, erfolgt die Zähmung ganz normal mit den bevorzugten Nahrungsmitteln.</li>
									</ul>
								</ul>
							</div>
						</div>
					</div>
				</div>
      </div>
      {isModalOpen && <ModalBlocker setModalImage={setModalImage} imageOnly={true} imageSrc={modalImage} />}
    </>
  )
}

export default Serverpage;